import { Spinner } from "react-bootstrap";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import StashItem from "../stash-item";
import {
    setStash,
    setStashActiveAlbumMedias,
    setStashAlbumGetInfo,
} from "../../../../redux/actions/stash";
import OrderModal from "../../../private-pages/messages/OrderModal";

const AlbumMediaList = ({
    activeAlbum,
    hasMore,
    mediaFiles,
    loadingStash,
    maxSelection = 0,
    orderModal,
    stash,
    source,
    stashSidebar,
    convList,
    broadcastModal,
    albumGetMediaInfo,
    convIndex,
    stashMediaFiles,
    addMediaToAlbum,
}) => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageChange, setPageChange] = useState(0);
    const [mediaInfDone, setMediaInfDone] = useState(false);
    const [lastMessageDone, setLastMessageDone] = useState(false);
    const [tmpLastMessage, setTmpLastMessage] = useState({});
    const [tmpStashMediaInformation, setTmpStashMediaInformation] = useState({});

    useEffect(() => {
        const updatedAlbumData = stash.albums.filter((album) => album.id === activeAlbum.id)[0];

        if (updatedAlbumData !== undefined && activeAlbum.medias_img_count !== updatedAlbumData.medias_img_count) {
            const payload = {
                activeAlbum: updatedAlbumData,
                addMediaToAlbum: false,
                moveToAlbum: false,
            };
            dispatch(setStash({
                ...stash,
                ...payload,
            }));
        }
    }, [activeAlbum]);

    const observer = useRef();
    const lastStashElementRef = useCallback(node => {
        if (loadingStash) return;
        if (observer.current) {
            observer.current.disconnect();
        }

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setCurrentPage(currentPage + 1);
                setPageChange(pageChange + 1);
            }
        });

        if (node) observer.current.observe(node);
        return () => {
            observer.current.disconnect();
        };
    }, [loadingStash, hasMore]);

    const addAlbumStashLib = () => {
        const payload = {
            albumAction: 'view_album',
            addMediaToAlbum: true,
            stashSelected: activeAlbum.medias,
        };

        dispatch(setStash({
            ...stash,
            ...payload,
        }));
    };

    useEffect(() => {
        // do nothing
        if (!stashSidebar && mediaFiles.length > 0) {
            const mediaIds = mediaFiles.map(media => media.media_id);
            dispatch(setStashAlbumGetInfo(mediaIds));
        }
    }, []);

    const getLatestMessage = async (medias) => {
        await axios.get('/api/medias/latest-message', {
            params: {
                media_ids: albumGetMediaInfo,
            }
        }).then(response => {
            setLastMessageDone(true);
            setTmpLastMessage(response.data);
        })
            .catch(error => {
                console.error({ error });
            });
    };

    const getStashMediaInformation = async () => {
        let otherUserId = '';
        if (convList) {
            const loggedInUser = localStorage.getItem('loggedin_user');
            const activeConversation = convList[convIndex];
            if (activeConversation && Object.keys(activeConversation).length > 0 && activeConversation['user_a'] == loggedInUser) {
                otherUserId = activeConversation['user_b'];
            }

            if (activeConversation && Object.keys(activeConversation).length > 0 && activeConversation['user_b'] == loggedInUser) {
                otherUserId = activeConversation['user_a'];
            }
        }

        await axios.get('/api/medias/message-information', {
            params: {
                media_ids: albumGetMediaInfo,
                sidebar: stashSidebar || broadcastModal,
                other_user: localStorage.getItem('other_user')
            }
        })
            .then(response => {
                dispatch(setStashAlbumGetInfo([]));
                setMediaInfDone(true);
                setTmpStashMediaInformation(response.data);
            })
            .catch(error => {
                console.error({ error });
            });
    };

    useEffect(() => {
        if (mediaInfDone && lastMessageDone) {
            setLastMessageDone(false);
            setMediaInfDone(false);

            let tmp = [...mediaFiles];
            if (tmpLastMessage.length > 0) {
                for (let i = 0;i < tmpLastMessage.length;i++) {
                    // index of response from existing media files
                    const index = mediaFiles.findIndex(mediaFile => mediaFile.media_id == tmpLastMessage[i].media_id);
                    if (index >= 0) {
                        tmp[index].latest_message = tmpLastMessage[i].messages;
                    }
                }
            }

            // loop
            if (tmpStashMediaInformation.length > 0) {
                for (let i = 0;i < tmpStashMediaInformation.length;i++) {
                    // index of response from existing media files
                    const index = mediaFiles.findIndex(mediaFile => mediaFile.media_id == tmpStashMediaInformation[i].media_id);
                    if (index >= 0) {
                        tmp[index].messages = tmpStashMediaInformation[i].latest_message;
                    }
                }
            }

            dispatch(setStashActiveAlbumMedias(tmp));
        }
    }, [tmpStashMediaInformation, tmpLastMessage]);

    useEffect(() => {
        // do nothing
        if (!stashSidebar && mediaFiles.length > 0 && albumGetMediaInfo.length > 0) {
            getLatestMessage();
            getStashMediaInformation();
        }
    }, [albumGetMediaInfo]);

    return <>
        {
            !addMediaToAlbum && <div className={"edit_album_add_existing"}>
                <p className="edit_album_view_stash_cont" style={{ display: 'block' }}>Add existing media from your
                    main <span className="edit_album_view_stash" onClick={() => {
                        addAlbumStashLib();
                    }}>Stash library</span> or upload new media.
                </p>
                <p>Click Reorder and then drag-drop media into another position in your album.</p>
            </div>
        }
        {
            loadingStash && mediaFiles.length === 0 && <div className="preloading-container">
                <Spinner size="lg" animation="border" variant="primary" />
            </div>
        }

        {/* Spinner with existing medias */}
        {
            !loadingStash && <div className={'media_container_album'} id="stash-cont">
                {
                    addMediaToAlbum === false && mediaFiles && mediaFiles.hasOwnProperty('length') && mediaFiles.length > 0 && mediaFiles.map((k, index) => {
                            return (mediaFiles.length === index + 1)
                                ? <StashItem key={k.media_id} item={k} max={maxSelection} source={source} ref={lastStashElementRef} />
                                : <StashItem key={k.media_id} item={k} max={maxSelection} source={source} />;
                        })
                }
                {
                    addMediaToAlbum === true && stashMediaFiles && stashMediaFiles.hasOwnProperty('length') && stashMediaFiles.length > 0 && stashMediaFiles.map((k, index) => {
                        return (stashMediaFiles.length === index + 1)
                            ? <StashItem key={k.media_id} item={k} max={maxSelection} source={source} ref={lastStashElementRef} />
                            : <StashItem key={k.media_id} item={k} max={maxSelection} source={source} />;
                    })
                }
                {
                    loadingStash && <div className="text-center p4" style={{ display: 'block', width: '100%' }}>
                        <Spinner size="md" animation="border" variant="primary" />
                    </div>
                }
            </div>
        }

        {orderModal && <OrderModal show={orderModal} />}
    </>;
};

const mapStateToProps = state => {
    return {
        activeAlbum: state.stash.activeAlbum,
        albumAction: state.stash.albumAction,
        albumList: state.stash.albums,
        hasMore: state.stash.hasMore,
        loadingStash: state.stash.busy,
        mediaFiles: state.stash.activeAlbum.medias,
        orderModal: state.stash.orderModal,
        stash: state.stash,
        stashMediaFiles: state.stash.medias,
        addMediaToAlbum: state.stash.addMediaToAlbum,
        stashSidebar: state.stash.stashSidebar,
        albumGetMediaInfo: state.stash.albumGetMediaInfo,
        convList: state.message.convList,
        broadcastModal: state.message.broadcastModal,
        convIndex: state.message.convIndex,
    };
};

export default connect(mapStateToProps)(AlbumMediaList);
